<template>
  <CardWithTitle
    :item-id="itemId"
    :request-status="requestStatus"
    :options-data="cardOptionsWithCSVExportOption"
    @call-option-menu="callOptionMenu"
    @reload="$emit('reload', $event)"
  >
    <v-row
      no-gutters
      class="column-chart-container fill-height"
      justify="center"
    >
      <HighCharts
        v-if="hasData"
        :ref="chartRef"
        :key="itemId"
        class="chart"
        :options="chartOptions"
      />
    </v-row>
    <template #top-right-slot>
      <Badge
        v-if="hasFilterApplied && isEditor"
        type="info"
        :tooltip="$t('components.Badge.label.tooltip.info')"
        :value="$t('components.Badge.label.icon.key')"
        :preset="true"
      />
    </template>
  </CardWithTitle>
</template>

<script>
import { Chart } from 'highcharts-vue';
import highChartsBasics from '@/mixins/highcharts-basics';
import cardsModel from '@/mixins/cards-model';
import exportModel from '@/mixins/export-model';
import CardWithTitle from '@/components/cards/models/CardWithTitle';
import merge from 'lodash/merge';
import Badge from '@/components/Badge';

export default {
  name: 'WordCloudChart',
  components: {
    HighCharts: Chart,
    CardWithTitle,
    Badge,
  },
  mixins: [
    highChartsBasics,
    cardsModel,
    exportModel,
  ],
  props: {
    requestStatus: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    data: {
      type: Array,
      default: () => ([]),
    },
    serieName: {
      type: String,
      default: 'Menções',
    },
    cardOptions: {
      type: [Array, Object],
      default: () => ([]),
    },
  },
  computed: {
    hasData() {
      return Object.keys(this.data).length;
    },
    chartOptions() {
      if (!this.hasData) {
        return {};
      }

      const customOptions = {
        legend: {
          enabled: false,
        },
        series: [{
          type: 'wordcloud',
          data: this.data,
          name: this.serieName,
        }],
      };

      return merge({}, this.highchartsBasics, this.highchartTheme, customOptions, this.cardOptions);
    },
  },
};
</script>

<style scoped lang="scss">
  .chart {
    width: 100%;
  }
</style>
